export default {
    en: {
        current_storage: "Current Storage",
        change_storage_label: "New Storage Amount",
        after_change_storage: "Storage After Change",
        payment_now: "Amount Due Now",
        payment_next_month: "Next Month Payment",
        storage_change_notice_1: "Your current storage is available until the next billing date,",
        storage_change_notice_2: "and changes will be applied from the next billing date.",
        change_btn: "Change",
        reservation_complete: "Storage change reservation completed.",
        error_occurred: "An error occurred.",
        addon_purchase_title: "Add-on Purchase",
        payment_complete_message: "Payment completed successfully.",
        storage_purchase_basis: "Storage Purchase Policy",
        credit_purchase_basis: "Credit Purchase Policy",
        current_payment_amount: "Current Payment Amount",
        storage_auto_renew_desc: "Monthly auto-renewal for storage (Cancel anytime before next billing)",
        credit_exhaust_desc: "Additional credits used after base credits are exhausted",
        storage_renew_desc: "Storage renews when subscription renews",
        credit_carryover_desc: "Remaining additional credits roll over automatically",
        purchase: "Purchase",
        pay_verb: "Pay",
        addon_refund_policy: "Refunds are only possible through the payment method used at the time of payment, in accordance with regulations.",
        addon_expiration_policy: "The usage period is 1 year from the date of purchase, and it will automatically expire after the period."
    },
    ko: {
        current_storage: "현재 사용 중인 스토리지",
        change_storage_label: "변경할 스토리지",
        after_change_storage: "변경 후 스토리지",
        payment_now: "지금 결제 금액",
        payment_next_month: "다음 달 결제 금액",
        storage_change_notice_1: "현재 사용 중인 스토리지는 다음 결제일 전까지 이용 가능하며,",
        storage_change_notice_2: "변경 사항은 다음 결제일부터 적용됩니다.",
        change_btn: "변경하기",
        reservation_complete: "스토리지 변경 예약이 완료되었습니다.",
        error_occurred: "오류가 발생했습니다.",
        addon_purchase_title: "추가 구매",
        payment_complete_message: "결제가 완료되었습니다.",
        storage_purchase_basis: "스토리지 구매 기준",
        credit_purchase_basis: "크레딧 구매 기준",
        current_payment_amount: "현재 결제금액",
        storage_auto_renew_desc: "스토리지 월 단위 자동 갱신 (다음 결제일 전 해지 가능)",
        credit_exhaust_desc: "기본 크레딧 소진 후 추가 크레딧 사용",
        storage_renew_desc: "구독 갱신 될때 스토리지도 갱신됩니다",
        credit_carryover_desc: "남은 추가 크레딧 자동 이월",
        purchase: "구매하기",
        pay_verb: "결제하기",
        addon_refund_policy: "환불은 규정에 따라 결제 시 사용한 결제 수단으로만 가능",
        addon_expiration_policy: "사용 기간은 구매일로부터 1년이며, 기간 경과 시 자동 소멸"
    },
    ja: {
        current_storage: "現在使用中のストレージ",
        change_storage_label: "変更するストレージ",
        after_change_storage: "変更後のストレージ",
        payment_now: "今回の決済金額",
        payment_next_month: "翌月の決済金額",
        storage_change_notice_1: "現在使用中のストレージは次回決済日前まで利用可能であり、",
        storage_change_notice_2: "変更内容は次回決済日から適用されます。",
        change_btn: "変更する",
        reservation_complete: "ストレージ変更予約が完了しました。",
        error_occurred: "エラーが発生しました。",
        addon_purchase_title: "追加購入",
        payment_complete_message: "決済が完了しました。",
        storage_purchase_basis: "ストレージ購入基準",
        credit_purchase_basis: "クレジット購入基準",
        current_payment_amount: "現在の決済金額",
        storage_auto_renew_desc: "ストレージ月額自動更新(次回決済日前に解約可能)",
        credit_exhaust_desc: "基本クレジット消化後、追加クレジット使用",
        storage_renew_desc: "サブスクリプション更新時にストレージも更新されます",
        credit_carryover_desc: "残りの追加クレジットは自動繰り越し",
        purchase: "購入する",
        pay_verb: "決済する",
        addon_refund_policy: "払い戻しは規定に従い、決済時に使用した決済手段でのみ可能です。",
        addon_expiration_policy: "使用期間は購入日から1年であり、期間経過時に自動消滅します。"
    }
};
